// extracted by mini-css-extract-plugin
module.exports = {"sortGroup":"moveActionDialog_sortGroup__al37O","branchGroup":"moveActionDialog_branchGroup__26Q1L","sequentialChildren":"moveActionDialog_sequentialChildren__1yQ3Z"};